import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import * as Types from './types';
import { Dispatch } from 'redux';
import * as RequestInformation from '../../../services/api/info_request';

interface IVatReturnRequestPayload {
  schemeType: number;
  memberState: number;
  vatNumber?: string;
  intNumber?: string;
  requestType?: 'MSOCN' | 'MSEST';
  vatReturnReference?: string;
  vatReturnVersion?: string;
  vatReturnPeriodQuarter?: number;
  vatReturnPeriodYear?: number;
  country?: number;
}

interface IRegistrationRequestPayload {
  schemeType: number;
  memberState: number;
  vatNumber?: string;
  tradeDate?: Date;
  intNumber?: string;
  contractRelationship?: boolean;
  vatTaxRef?: string;
  netpIntermediaryStatus?: string;
}

class FetchMemberState implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('SetMemberState Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class SetRegistrationRequest implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REGISTRATION_REQUEST,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REGISTRATION_REQUEST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REGISTRATION_REQUEST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IRegistrationRequestPayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await RequestInformation.requestRegistrationInformation(
          payload.schemeType,
          payload.memberState,
          payload.vatNumber,
          payload.tradeDate,
          payload.intNumber,
          payload.contractRelationship,
          payload.vatTaxRef,
          payload.netpIntermediaryStatus
        );
        dispatch(this.onSuccess(null));
      } catch (error: any) {
        // console.log('SetRegistrationRequest Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class SetVatReturnRequest implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_REQUEST,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VATRETURN_REQUEST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_REQUEST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IVatReturnRequestPayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await RequestInformation.requestVatReturnInformation(
          payload.schemeType,
          payload.memberState,
          payload.vatNumber,
          payload.intNumber,
          payload.requestType,
          payload.vatReturnReference,
          payload.vatReturnVersion,
          payload.vatReturnPeriodQuarter,
          payload.vatReturnPeriodYear,
          payload.country
        );
        dispatch(this.onSuccess(null));
      } catch (error: any) {
        // console.log('SetVatReturnRequest Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchAllCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getAllCountries();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchAllCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchMemberStateAction: () => new FetchMemberState().action(),
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchAllCountriesAction: () => new FetchAllCountries().action(),
  registrationRequestAction: (payload: IRegistrationRequestPayload) =>
    new SetRegistrationRequest().action(payload),
  vatReturnRequestAction: (payload: IVatReturnRequestPayload) =>
    new SetVatReturnRequest().action(payload),
};
